export function getMarkConversationEventPayload(conversationID: number): {
  conid: string;
} {
  return { conid: conversationID.toString() };
}
